module.exports = __webpack_public_path__ + "static/media/android_logo.d63d981f.png";